import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
interface AppProps {
  showSocialProof?: boolean;
}
export function App({
  showSocialProof = true
}: AppProps) {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-green/20" data-id="element-0" data-mp="3rc9f0ac2njyt">
      <main data-id="element-1" data-mp="5or2zhbcs60">
        <HeroSection onCtaClick={scrollToPricing} data-id="element-2" data-mp="6htjo98ovic" />
        <StatsBar data-id="element-3" data-mp="82kz509bybz" />
        <TransformationSection data-id="element-4" data-mp="2zl3azit8d249" />
        <PainPointsSection data-id="element-5" data-mp="2zlv8iz6e19x6" />
        <KitContentsSection data-id="element-6" data-mp="2zmo5x9jgin2n" />
        <InstantAccessSection data-id="element-7" data-mp="2znfyebhrc4op" />
        <BonusesSection data-id="element-8" data-mp="33lwy49yumcw3" />
        <PricingSection data-id="element-9" data-mp="33nghwajpr62m" />
        <GuaranteeSection data-id="element-10" data-mp="33orjc3pos1qk" />
        <TestimonialsSection data-id="element-11" data-mp="38m1elzzrb7mb" />
        <AboutSection data-id="element-12" data-mp="38kqafz2efxuo" />
        <FAQSection data-id="element-13" data-mp="38kgkucl9nspi" />
        <FinalCTASection onCtaClick={scrollToPricing} data-id="element-14" data-mp="38o4ercumih4r" />
      </main>
      <Footer data-id="element-15" data-mp="3dmfqjt4hb1pm" />
      {showSocialProof && <SocialProofPopup data-id="element-16" data-mp="nvj4bi5joiqs" />}
    </div>;
}